module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-housekeeping"
  }, [_c('v-tabs', {
    attrs: {
      "dark": "",
      "scrollable": false,
      "grow": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "to": tab.link,
        "exact": ""
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")])
  }), _vm._v(" "), _c('v-tabs-slider', {
    staticClass: "default-dark"
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c1ea74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TabsComponent.vue
// module id = 727
// module chunks = 108